/* global axios */
import ApiClient from './ApiClient';

class ShopsAPI extends ApiClient {
  constructor() {
    super('shops', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(shopData) {
    return axios.post(this.url, shopData);
  }

  update(id, shopData) {
    return axios.patch(`${this.url}/${id}`, shopData);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  getCategories() {
    return axios.get(`${this.url}/categories`);
  }
}

export default new ShopsAPI();
